(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(slider) {
    if (slider.dataset.bound === 'true') return;
    slider.dataset.bound = 'true';

    var before = slider.querySelector('[data-ba-before]');
    var handle = slider.querySelector('[data-ba-handle]');
    var hint = slider.querySelector('.ba-slider__hint');
    var labelBefore = slider.querySelector('.ba-slider__label--before');
    var labelAfter = slider.querySelector('.ba-slider__label--after');
    if (!before || !handle) return;

    var position = 50;
    var isDragging = false;
    var hasInteracted = false;

    // Thresholds: con qué % de slider el label opuesto se desvanece
    var HIDE_AFTER_AT  = 88;  // si pct >= 88 (mostrando MES 1) → ocultar label MES 3
    var HIDE_BEFORE_AT = 12;  // si pct <= 12 (mostrando MES 3) → ocultar label MES 1

    function setPosition(pct) {
      pct = Math.max(0, Math.min(100, pct));
      position = pct;

      // Clip del before: cuanto mayor el pct, menos clip (más BEFORE visible a la izquierda)
      before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));

      // Fade de labels según extremo
      if (labelBefore) labelBefore.style.opacity = pct > HIDE_BEFORE_AT ? '1' : '0';
      if (labelAfter)  labelAfter.style.opacity  = pct < HIDE_AFTER_AT  ? '1' : '0';

      if (!hasInteracted) {
        hasInteracted = true;
        if (hint) hint.style.opacity = '0';
      }
    }

    function getPercent(x) {
      var r = slider.getBoundingClientRect();
      return ((x - r.left) / r.width) * 100;
    }

    function onDown(e) {
      isDragging = true;
      slider.classList.add('is-dragging');
      e.preventDefault();
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(getPercent(x));
    }
    function onMove(e) {
      if (!isDragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(getPercent(x));
    }
    function onUp() {
      isDragging = false;
      slider.classList.remove('is-dragging');
    }

    slider.addEventListener('mousedown', onDown);
    slider.addEventListener('touchstart', onDown, { passive: false });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: true });
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchend', onUp);

    handle.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown')      { e.preventDefault(); setPosition(position - step); }
      else if (e.key === 'ArrowRight' || e.key === 'ArrowUp')  { e.preventDefault(); setPosition(position + step); }
      else if (e.key === 'Home')                                { e.preventDefault(); setPosition(0); }
      else if (e.key === 'End')                                 { e.preventDefault(); setPosition(100); }
    });

    setPosition(50);
    if (hint) setTimeout(function () { if (!hasInteracted) hint.classList.add('is-pulsing'); }, 1000);
  }

  document.querySelectorAll('[data-ba-slider]').forEach(initSlider);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ba-slider]').forEach(initSlider);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Gallery
  function initGallery(gallery) {
    // Guard propio de hero-product: hero.liquid usa el suyo. Shopify
    // concatena todos losen un bundle global, asi que
    // un guard generico como "data-bound" hace que las dos secciones
    // compitan por el mismo nodo y gane la que corra primero.
    if (gallery.dataset.hpGalleryBound === 'true') return;
    gallery.dataset.hpGalleryBound = 'true';
    var slides = gallery.querySelectorAll('[data-hero-slide]');
    var dots = gallery.querySelectorAll('[data-hero-dot]');
    var prev = gallery.querySelector('[data-hero-prev]');
    var next = gallery.querySelector('[data-hero-next]');
    var thumbsContainer = gallery.parentElement.querySelector('.hero-product__thumbs');
    var thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('[data-hero-thumb]') : [];
    if (slides.length < 2) return;
    var current = 0, total = slides.length;

    // El thumb activo se trae a la vista aunque el cambio venga de las
    // flechas, no solo de un click sobre el thumb (criterio 18.2).
    function scrollThumbIntoView(idx) {
      if (!thumbsContainer || !thumbs[idx]) return;
      var t = thumbs[idx];
      var cLeft = thumbsContainer.scrollLeft;
      var cRight = cLeft + thumbsContainer.clientWidth;
      var tLeft = t.offsetLeft;
      var tRight = tLeft + t.offsetWidth;
      if (tLeft < cLeft) thumbsContainer.scrollLeft = tLeft - 12;
      else if (tRight > cRight) thumbsContainer.scrollLeft = tRight - thumbsContainer.clientWidth + 12;
    }

    var leaving = null;

    function go(idx) {
      idx = (idx + total) % total;
      if (idx === current) return;

      // Direccion del desplazamiento. En el salto de la ultima a la
      // primera (y al reves) manda el sentido del giro, no la resta de
      // indices, que ahi da al revez de lo que el usuario hizo.
      var dir = idx > current ? 'next' : 'prev';
      if (current === total - 1 && idx === 0) dir = 'next';
      else if (current === 0 && idx === total - 1) dir = 'prev';
      gallery.classList.toggle('is-dir-prev', dir === 'prev');

      // La que sale se marca para que salga hacia el mismo lado que entra
      // la nueva. La marca se limpia en el cambio siguiente: sin timers ni
      // transitionend, que se pierden si el usuario pasa fotos rapido.
      if (leaving) leaving.classList.remove('is-leaving');
      leaving = slides[current];
      if (leaving) leaving.classList.add('is-leaving');

      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
        if (i !== idx) s.setAttribute('aria-hidden', 'true');
        else s.removeAttribute('aria-hidden');
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === idx);
        t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
      current = idx;
      scrollThumbIntoView(idx);
    }
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });

    // Arrastre con mouse en la franja de miniaturas. Si el puntero se
    // movio mas de 6px es un drag, no un click: se suprime el click del
    // thumb para no cambiar de slide sin querer.
    if (thumbsContainer) {
      var dragging = false, dragStartX = 0, dragStartScroll = 0, moved = 0;
      thumbsContainer.addEventListener('mousedown', function (e) {
        dragging = true; moved = 0;
        dragStartX = e.pageX;
        dragStartScroll = thumbsContainer.scrollLeft;
      });
      thumbsContainer.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        var delta = e.pageX - dragStartX;
        moved = Math.abs(delta);
        if (moved > 6) thumbsContainer.classList.add('is-dragging');
        thumbsContainer.scrollLeft = dragStartScroll - delta;
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        setTimeout(function () { thumbsContainer.classList.remove('is-dragging'); }, 0);
      }
      thumbsContainer.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', endDrag);
    }

    // Swipe de la imagen principal: solo se toma como swipe si el gesto
    // es mas horizontal que vertical, para no secuestrar el scroll.
    var startX = 0, startY = 0, isTouching = false;
    gallery.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isTouching = true;
    }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (!isTouching) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(current + (dx < 0 ? 1 : -1));
      isTouching = false;
    }, { passive: true });
  }

  // Bundle selector + add to cart
  function initBundles(container) {
    if (container.dataset.hpBundlesBound === 'true') return;
    container.dataset.hpBundlesBound = 'true';

    var radios = container.querySelectorAll('[data-bundle-radio]');
    var cards = container.querySelectorAll('[data-bundle-card]');
    var addBtn = container.querySelector('[data-hero-bundles-add]');

    function formatMoney(cents) {
      var amount = cents / 100;
      var formatted = Math.round(amount).toLocaleString('es-AR');
      return '$' + formatted;
    }

    // Antes esto era un no-op: el comprador tildaba un upsell pago, el
    // precio de la tarjeta no se movia, y el carrito le cobraba mas.
    function updateCardPrice(card) {
      var radio = card.querySelector('[data-bundle-radio]');
      var display = card.querySelector('[data-price-display]');
      if (!radio || !display) return;
      var base = parseInt(radio.getAttribute('data-bundle-price') || '0', 10);
      if (!base) return;
      var total = base;
      card.querySelectorAll('[data-bundle-upsell]').forEach(function (up) {
        var cb = up.querySelector('[data-upsell-checkbox]');
        var isOn = up.getAttribute('data-upsell-always-on') === 'true' || (cb && cb.checked);
        if (!isOn) return;
        var p = parseInt(up.getAttribute('data-upsell-price') || '0', 10);
        if (p) total += p;
      });
      display.textContent = formatMoney(total);
      card.setAttribute('data-current-total', total);
      if (card.classList.contains('is-selected')) emitVariantChange(card);
    }

    // Las secciones independientes (sticky ATC) se enteran por evento.
    // El radio esta oculto y se marca por asignacion programatica, que
    // NO dispara 'change': depender de eso dejaba el sticky desfasado.
    function emitVariantChange(card) {
      var radio = card.querySelector('[data-bundle-radio]');
      if (!radio) return;
      var title = card.querySelector('.hero-bundle-card__title');
      var sub = card.querySelector('.hero-bundle-card__subtitle');
      var display = card.querySelector('[data-price-display]');
      var img = card.querySelector('.hero-bundle-card__media img');
      var detail = {
        variantId: radio.value || radio.getAttribute('data-variant-id') || '',
        price: display ? display.textContent.trim() : '',
        label: [title ? title.textContent.trim() : '', sub ? sub.textContent.trim() : '']
          .filter(Boolean).join(' - '),
        image: img ? img.getAttribute('src') : '',
        available: !radio.disabled
      };
      var ev;
      try {
        ev = new CustomEvent('variant:changed', { detail: detail, bubbles: true });
      } catch (e) {
        ev = document.createEvent('CustomEvent');
        ev.initCustomEvent('variant:changed', true, false, detail);
      }
      document.dispatchEvent(ev);
    }

    function fetchUpsellPrices(card) {
      if (typeof window.fetch !== 'function') return;
      var upsells = card.querySelectorAll('[data-bundle-upsell][data-upsell-variant-id]');
      var jobs = [];
      for (var i = 0; i < upsells.length; i++) {
        (function (up) {
          if (up.getAttribute('data-upsell-price')) return;
          var vid = up.getAttribute('data-upsell-variant-id');
          if (!vid) return;
          jobs.push(
            fetch('/variants/' + vid + '.js')
              .then(function (res) { return res.ok ? res.json() : null; })
              .then(function (data) {
                if (data && data.price) up.setAttribute('data-upsell-price', data.price);
              })
              .catch(function () {})
          );
        })(upsells[i]);
      }
      Promise.all(jobs).then(function () { updateCardPrice(card); });
    }

    function registerBundleUpsellPairs(bundleVariantId, upsellVariantIds) {
      try {
        var pairs = JSON.parse(sessionStorage.getItem('alevia_bundle_pairs') || '[]');
        pairs = pairs.filter(function (p) { return p.bundle !== bundleVariantId; });
        if (upsellVariantIds.length > 0) {
          pairs.push({ bundle: bundleVariantId, upsells: upsellVariantIds });
        }
        sessionStorage.setItem('alevia_bundle_pairs', JSON.stringify(pairs));
      } catch (e) {}
    }

    function enforceCartBundleUpsells(cart) {
      try {
        var pairs = JSON.parse(sessionStorage.getItem('alevia_bundle_pairs') || '[]');
        if (!pairs.length) return;
        var cartVariantIds = (cart.items || []).map(function (i) { return String(i.variant_id); });
        function has(id) { return cartVariantIds.indexOf(String(id)) !== -1; }
        var toRemove = [];
        pairs.forEach(function (pair) {
          if (has(pair.bundle)) return;
          pair.upsells.forEach(function (uid) { if (has(uid)) toRemove.push(String(uid)); });
        });
        if (!toRemove.length || typeof window.fetch !== 'function') return;
        var updates = {};
        toRemove.forEach(function (uid) { updates[uid] = 0; });
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (newCart) {
            if (!newCart) return;
            var ev;
            try {
              ev = new CustomEvent('cart:updated', { detail: newCart, bubbles: true });
            } catch (e2) {
              ev = document.createEvent('CustomEvent');
              ev.initCustomEvent('cart:updated', true, false, newCart);
            }
            document.dispatchEvent(ev);
          })
          .catch(function () {});
      } catch (e) {}
    }

    function resetCardUpsells(card) {
      card.querySelectorAll('[data-bundle-upsell]').forEach(function (up) {
        var isAlwaysOn = up.getAttribute('data-upsell-always-on') === 'true';
        var isDefault = up.getAttribute('data-upsell-default-checked') === 'true';
        var shouldBeChecked = isAlwaysOn || isDefault;
        var cb = up.querySelector('[data-upsell-checkbox]');
        if (cb) cb.checked = shouldBeChecked;
        if (shouldBeChecked) up.classList.add('is-checked');
        else up.classList.remove('is-checked');
      });
      updateCardPrice(card);
    }

    function updateSelection() {
      var selectedCard = null;
      cards.forEach(function (card) {
        var input = card.querySelector('[data-bundle-radio]');
        var wasSelected = card.classList.contains('is-selected');
        var isSelected = !!(input && input.checked);
        if (isSelected) {
          selectedCard = card;
          card.classList.add('is-selected');
          if (!wasSelected) {
            resetCardUpsells(card);
            fetchUpsellPrices(card);
          }
        } else {
          card.classList.remove('is-selected');
        }
      });

      if (!selectedCard) return;

      // El input name="id" del form nativo tiene que seguir al plan
      // elegido: si no, el fallback sin JS compraria siempre la primera
      // variante.
      var radio = selectedCard.querySelector('[data-bundle-radio]');
      var hidden = container.querySelector('[data-hero-bundles-variant]');
      if (radio && radio.value && hidden) hidden.value = radio.value;
      if (radio && radio.value && addBtn) addBtn.setAttribute('data-variant-id', radio.value);

      emitVariantChange(selectedCard);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-bundle-upsell]')) return;
        var input = card.querySelector('[data-bundle-radio]');
        if (input && !input.disabled && !input.checked) {
          input.checked = true;
          updateSelection();
        }
      });

      card.querySelectorAll('[data-bundle-upsell]').forEach(function (up) {
        var cb = up.querySelector('[data-upsell-checkbox]');
        if (!cb) return;
        if (up.getAttribute('data-upsell-always-on') === 'true') {
          up.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
          return;
        }
        cb.addEventListener('change', function () {
          if (cb.checked) up.classList.add('is-checked');
          else up.classList.remove('is-checked');
          updateCardPrice(card);
        });
      });

      if (card.classList.contains('is-selected')) {
        resetCardUpsells(card);
        fetchUpsellPrices(card);
      }
    });

    radios.forEach(function (r) { r.addEventListener('change', updateSelection); });

    document.addEventListener('cart:updated', function (e) {
      if (e.detail) enforceCartBundleUpsells(e.detail);
    });

    if (addBtn) {
      // Se escucha 'submit' en el form (no 'click' en el boton) y se
      // corta la propagacion: dos listeners sobre el mismo form
      // terminarian mandando dos veces /cart/add (regla 78).
      var addForm = addBtn.closest('form') || addBtn;
      var addEvent = addForm.tagName === 'FORM' ? 'submit' : 'click';

      addForm.addEventListener(addEvent, function (e) {
        // Sin fetch no interceptamos: el form nativo hace el POST solo.
        if (typeof window.fetch !== 'function') return;
        e.preventDefault();
        e.stopPropagation();
        if (addBtn.hasAttribute('aria-busy')) return;

        var selected = container.querySelector('[data-bundle-radio]:checked');
        if (!selected || !selected.value) return;

        var bundleVariantId = parseInt(selected.value, 10);
        var items = [{ id: bundleVariantId, quantity: 1 }];
        var upsellVariantIds = [];

        var selectedCard = selected.closest('[data-bundle-card]');
        if (selectedCard) {
          selectedCard.querySelectorAll('[data-bundle-upsell].is-checked').forEach(function (up) {
            var vid = up.getAttribute('data-upsell-variant-id');
            if (vid) {
              var parsed = parseInt(vid, 10);
              if (!isNaN(parsed) && parsed > 0) {
                items.push({ id: parsed, quantity: 1 });
                upsellVariantIds.push(parsed);
              }
            }
          });
        }

        registerBundleUpsellPairs(String(bundleVariantId), upsellVariantIds.map(String));

        addBtn.setAttribute('aria-busy', 'true');
        var txtSpan = addBtn.querySelector('.add-to-cart-text');
        var originalText = txtSpan ? txtSpan.textContent : '';
        if (txtSpan) txtSpan.textContent = 'Agregando...';

        function restore() {
          if (txtSpan) txtSpan.textContent = originalText;
          addBtn.removeAttribute('aria-busy');
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(
                function (b) { throw new Error(b.description || b.message || 'Error'); },
                function () { throw new Error('Error del carrito (' + res.status + ')'); }
              );
            }
            return res.json();
          })
          .then(function () {
            if (!window.AleviaCart) return;
            return window.AleviaCart.fetch().then(function (cart) {
              var ev;
              try {
                ev = new CustomEvent('cart:updated', { detail: cart, bubbles: true });
              } catch (e2) {
                ev = document.createEvent('CustomEvent');
                ev.initCustomEvent('cart:updated', true, false, cart);
              }
              document.dispatchEvent(ev);
              window.AleviaCart.open();
              return window.AleviaCart.refresh();
            });
          })
          .then(restore)
          .catch(function (err) {
            if (window.console) console.warn('[alevia] bundles:', err.message);
            var live = container.querySelector('[data-bundles-error]');
            if (live) live.textContent = err.message;
            restore();
          });
      });
    }
  }

  // FAQ con auto-cierre (single-open): al abrir una, las otras se cierran
  function initFaq(list) {
    if (list.dataset.bound === 'true') return;
    list.dataset.bound = 'true';
    if (list.dataset.singleOpen !== 'true') return;
    var items = list.querySelectorAll('.hero-faq__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) { if (other !== item) other.open = false; });
        }
      });
    });
  }

  document.querySelectorAll('[data-hero-gallery]').forEach(initGallery);
  document.querySelectorAll('[data-hero-bundles]').forEach(initBundles);
  document.querySelectorAll('.hero-faq__list').forEach(initFaq);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hero-gallery]').forEach(initGallery);
    e.target.querySelectorAll('[data-hero-bundles]').forEach(initBundles);
    e.target.querySelectorAll('.hero-faq__list').forEach(initFaq);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Gallery
  function initGallery(gallery) {
    if (gallery.dataset.bound === 'true') return;
    gallery.dataset.bound = 'true';
    var slides = gallery.querySelectorAll('[data-hero-slide]');
    var dots = gallery.querySelectorAll('[data-hero-dot]');
    var prev = gallery.querySelector('[data-hero-prev]');
    var next = gallery.querySelector('[data-hero-next]');
    var thumbsContainer = gallery.parentElement.querySelector('.hero-product__thumbs');
    var thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('[data-hero-thumb]') : [];
    if (slides.length < 2) return;
    var current = 0, total = slides.length;
    function go(idx) {
      idx = (idx + total) % total;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); if (i !== idx) s.setAttribute('aria-hidden', 'true'); else s.removeAttribute('aria-hidden'); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      current = idx;
    }
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var startX = 0, isTouching = false;
    gallery.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; isTouching = true; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (!isTouching) return;
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 50) go(current + (diff < 0 ? 1 : -1));
      isTouching = false;
    });
  }

  // Bundle selector + add to cart
  function initBundles(container) {
    if (container.dataset.bound === 'true') return;
    container.dataset.bound = 'true';

    var radios = container.querySelectorAll('[data-bundle-radio]');
    var cards = container.querySelectorAll('[data-bundle-card]');
    var addBtn = container.querySelector('[data-hero-bundles-add]');

    function updateSelection() {
      cards.forEach(function (card) {
        var input = card.querySelector('[data-bundle-radio]');
        if (input && input.checked) card.classList.add('is-selected');
        else card.classList.remove('is-selected');
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        // El click en el label naturalmente activa el radio
        // Pero si clickea en otro lado del card, también activa
        var input = card.querySelector('[data-bundle-radio]');
        if (input && !input.disabled && !input.checked) {
          input.checked = true;
          updateSelection();
        }
      });
    });

    radios.forEach(function (r) {
      r.addEventListener('change', updateSelection);
    });

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (addBtn.hasAttribute('aria-busy')) return;

        var selected = container.querySelector('[data-bundle-radio]:checked');
        if (!selected) {
          alert('Elegí un plan primero');
          return;
        }
        if (!selected.value) {
          alert('El producto aún no está configurado. Asegurate que el handle del producto en los settings de la sección coincida con un producto publicado.');
          return;
        }

        var variantId = selected.value;
        addBtn.setAttribute('aria-busy', 'true');
        var txtSpan = addBtn.querySelector('.add-to-cart-text');
        var originalText = txtSpan ? txtSpan.textContent : '';
        if (txtSpan) txtSpan.textContent = 'Agregando...';

        function restore() {
          if (txtSpan) txtSpan.textContent = originalText;
          addBtn.removeAttribute('aria-busy');
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(
                function (b) { throw new Error(b.description || b.message || 'Error'); },
                function () { throw new Error('Error del carrito (' + res.status + ')'); }
              );
            }
            return res.json();
          })
          .then(function () {
            if (!window.AleviaCart) return;
            return window.AleviaCart.fetch().then(function (cart) {
              var ev;
              try {
                ev = new CustomEvent('cart:updated', { detail: cart, bubbles: true });
              } catch (e2) {
                ev = document.createEvent('CustomEvent');
                ev.initCustomEvent('cart:updated', true, false, cart);
              }
              document.dispatchEvent(ev);
              window.AleviaCart.open();
              return window.AleviaCart.refresh();
            });
          })
          .then(restore)
          .catch(function (err) {
            if (window.console) console.warn('[alevia] hero:', err.message);
            restore();
          });
      });
    }
  }

  // Esta seccion comparte los selectores [data-hero-gallery] y
  // [data-hero-bundles] con hero-product.liquid, y Shopify concatena
  // TODOS los {% javascript %} en un unico bundle global. Sin scopear,
  // este IIFE se ata a los nodos de hero-product y termina mandando dos
  // veces /cart/add. Solo actuamos dentro de nuestro propio root.
  function heroLegacyRoots(scope) {
    return (scope || document).querySelectorAll('[data-hero-legacy]');
  }
  function bootLegacy(scope) {
    heroLegacyRoots(scope).forEach(function (root) {
      root.querySelectorAll('[data-hero-gallery]').forEach(initGallery);
      root.querySelectorAll('[data-hero-bundles]').forEach(initBundles);
    });
  }
  bootLegacy(document);
  document.addEventListener('shopify:section:load', function (e) {
    bootLegacy(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initIngredientsCarousel(section) {
    if (section.dataset.bound === 'true') return;
    section.dataset.bound = 'true';

    var track = section.querySelector('[data-ic-track]');
    var prev = section.querySelector('[data-ic-prev]');
    var next = section.querySelector('[data-ic-next]');
    var progress = section.querySelector('[data-ic-progress]');
    if (!track) return;

    function getScrollStep() {
      var card = track.querySelector('.ingredients-carousel__card');
      if (!card) return 300;
      var style = window.getComputedStyle(track);
      var gap = parseInt(style.columnGap || style.gap || '16', 10);
      return card.offsetWidth + gap;
    }

    function updateUI() {
      var cards = track.querySelectorAll('.ingredients-carousel__card');
      var totalCards = cards.length;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var current = track.scrollLeft;

      // Progreso basado en qué card está más cerca del centro del viewport
      var fillPct;
      if (totalCards > 0 && maxScroll > 0) {
        var trackRect = track.getBoundingClientRect();
        var trackCenter = trackRect.left + trackRect.width / 2;
        var closestIdx = 0;
        var closestDist = Infinity;
        cards.forEach(function (card, i) {
          var r = card.getBoundingClientRect();
          var cardCenter = r.left + r.width / 2;
          var dist = Math.abs(cardCenter - trackCenter);
          if (dist < closestDist) {
            closestDist = dist;
            closestIdx = i;
          }
        });
        // La card 0 = inicio de barra, la última = fin de barra
        fillPct = totalCards > 1
          ? (closestIdx / (totalCards - 1)) * 100
          : 100;
        // Mínimo visible para que la barra no quede en 0
        if (fillPct < 8) fillPct = 8;
      } else {
        fillPct = 100;
      }

      if (progress) progress.style.width = fillPct + '%';

      if (prev) {
        if (current <= 4) prev.setAttribute('disabled', '');
        else prev.removeAttribute('disabled');
      }
      if (next) {
        if (current >= maxScroll - 4) next.setAttribute('disabled', '');
        else next.removeAttribute('disabled');
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateUI, { passive: true });
    window.addEventListener('resize', updateUI);
    updateUI();
  }

  document.querySelectorAll('[data-ingredients-carousel]').forEach(initIngredientsCarousel);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ingredients-carousel]').forEach(initIngredientsCarousel);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initQuiz(quiz) {
    if (quiz.dataset.bound === 'true') return;
    quiz.dataset.bound = 'true';
    var steps = quiz.querySelectorAll('[data-step]');
    var results = quiz.querySelectorAll('[data-result]');
    var progress = quiz.querySelectorAll('[data-progress-step]');
    quiz.querySelectorAll('[data-quiz-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.stepTarget;
        steps.forEach(function (s) { s.classList.remove('is-active'); });
        results.forEach(function (r) { r.classList.remove('is-active'); });
        if (target.indexOf('result') === 0) {
          quiz.querySelector('[data-result="' + target + '"]').classList.add('is-active');
          progress.forEach(function (p) { p.classList.add('is-complete'); });
        } else {
          var nextStep = quiz.querySelector('[data-step="' + target + '"]');
          if (nextStep) {
            nextStep.classList.add('is-active');
            progress.forEach(function (p) {
              var idx = parseInt(p.dataset.progressStep, 10);
              p.classList.toggle('is-active', idx <= parseInt(target, 10));
            });
          }
        }
      });
    });
  }
  document.querySelectorAll('[data-quiz]').forEach(initQuiz);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-quiz]').forEach(initQuiz); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-addtocart"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStickyATC(bar) {
    if (bar.dataset.stickyBound === 'true') return;
    bar.dataset.stickyBound = 'true';

    var triggerSelector = bar.dataset.showAfter || '.hero-product';
    var triggerEl = document.querySelector(triggerSelector);
    var addBtn = bar.querySelector('[data-sticky-add]');
    var titleEl = bar.querySelector('[data-sticky-title]');
    var variantEl = bar.querySelector('[data-sticky-variant]');
    var priceEl = bar.querySelector('[data-sticky-price]');
    var priceOldEl = bar.querySelector('[data-sticky-price-old]');
    var imgEl = bar.querySelector('[data-sticky-image]');

    function setVisible(v) {
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
    }

    // Aparicion por IntersectionObserver sobre el boton principal de
    // compra, nunca por un umbral fijo en pixeles: un umbral no se
    // adapta a paginas de distinto largo (criterio 18.5 / regla 35).
    var sentinel = document.querySelector('[data-hero-bundles-add]') || triggerEl;

    if (sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Visible solo cuando el ATC principal ya quedo arriba de la
          // viewport; si todavia se ve, el sticky sobra.
          setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0, rootMargin: '0px' });
      io.observe(sentinel);
      setVisible(false);
    } else {
      // Fallback sin IntersectionObserver: scroll con rAF.
      var ticking = false;
      var fallbackCheck = function () {
        if (!sentinel) { setVisible(window.scrollY > 600); return; }
        setVisible(sentinel.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', function () {
        if (ticking) return;
        window.requestAnimationFrame(function () { fallbackCheck(); ticking = false; });
        ticking = true;
      }, { passive: true });
      fallbackCheck();
    }

    // Sincronizar con el bundle seleccionado del hero (si existe)
    function syncWithHeroBundle() {
      var heroBundles = document.querySelector('[data-hero-bundles]');
      if (!heroBundles) return;

      var selectedRadio = heroBundles.querySelector('[data-bundle-radio]:checked');
      if (!selectedRadio) return;

      // Actualizar variant id en el botón
      if (selectedRadio.value) {
        addBtn.setAttribute('data-variant-id', selectedRadio.value);
      }

      // Actualizar título del bundle (si el setting lo permite)
      var bundleTitle = selectedRadio.getAttribute('data-bundle-title');
      if (bundleTitle && variantEl) {
        variantEl.textContent = bundleTitle;
      }

      // Actualizar precio del bundle
      var selectedCard = selectedRadio.closest('[data-bundle-card]');
      if (selectedCard) {
        var bundlePrice = selectedCard.querySelector('.hero-bundle-card__price');
        var bundlePriceOld = selectedCard.querySelector('.hero-bundle-card__price-old');
        var bundleImg = selectedCard.querySelector('.hero-bundle-card__media img');

        if (bundlePrice && priceEl) {
          priceEl.textContent = bundlePrice.textContent.trim();
        }
        if (bundlePriceOld && priceOldEl) {
          priceOldEl.textContent = bundlePriceOld.textContent.trim();
          priceOldEl.style.display = '';
        } else if (priceOldEl) {
          priceOldEl.style.display = 'none';
        }
        if (bundleImg && imgEl) {
          imgEl.src = bundleImg.src;
        }
      }
    }

    // Inicial
    syncWithHeroBundle();

    // El radio del hero esta oculto y se marca por asignacion
    // programatica, que NO dispara 'change'. La sincronizacion va por
    // CustomEvent, que es lo que emite el hero al cambiar de plan.
    document.addEventListener('variant:changed', function (e) {
      var d = e.detail || {};
      if (d.variantId && addBtn) addBtn.setAttribute('data-variant-id', d.variantId);
      if (d.label && variantEl) variantEl.textContent = d.label;
      if (d.price && priceEl) priceEl.textContent = d.price;
      if (priceOldEl) priceOldEl.style.display = d.priceOld ? '' : 'none';
      if (d.priceOld && priceOldEl) priceOldEl.textContent = d.priceOld;
      if (d.image && imgEl) imgEl.src = d.image;
      if (addBtn && d.available === false) addBtn.setAttribute('disabled', 'disabled');
      else if (addBtn) addBtn.removeAttribute('disabled');
    });

    // Red de seguridad: si alguna variante si dispara change nativo.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-bundle-radio]')) {
        syncWithHeroBundle();
      }
    });

    // Click al carrito
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (addBtn.hasAttribute('aria-busy')) return;

        var variantId = addBtn.getAttribute('data-variant-id');
        if (!variantId) {
          alert('Producto no disponible. Recargá la página.');
          return;
        }

        addBtn.setAttribute('aria-busy', 'true');
        var longText = addBtn.querySelector('.sticky-atc__btn-text-long');
        var shortText = addBtn.querySelector('.sticky-atc__btn-text-short');
        var originalLong = longText ? longText.textContent : '';
        var originalShort = shortText ? shortText.textContent : '';
        if (longText) longText.textContent = 'Agregando...';
        if (shortText) shortText.textContent = '...';

        function restore() {
          if (longText) longText.textContent = originalLong;
          if (shortText) shortText.textContent = originalShort;
          addBtn.removeAttribute('aria-busy');
        }

        // ATC propio e independiente: su propio fetch a /cart/add.js con
        // la variante que rastrea, nunca simulando un click en el boton
        // principal (que puede no existir en el DOM de esta pagina).
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(
                function (b) { throw new Error(b.description || b.message || 'Error'); },
                function () { throw new Error('Error del carrito (' + res.status + ')'); }
              );
            }
            return res.json();
          })
          .then(function () {
            if (window.AleviaCart) {
              return window.AleviaCart.fetch().then(function (cart) {
                var ev;
                try {
                  ev = new CustomEvent('cart:updated', { detail: cart, bubbles: true });
                } catch (e2) {
                  ev = document.createEvent('CustomEvent');
                  ev.initCustomEvent('cart:updated', true, false, cart);
                }
                document.dispatchEvent(ev);
                window.AleviaCart.open();
                return window.AleviaCart.refresh();
              });
            }
          })
          .then(function () {
            if (longText) longText.textContent = 'Agregado';
            if (shortText) shortText.textContent = 'OK';
            setTimeout(restore, 1500);
          })
          .catch(function (err) {
            if (window.console) console.warn('[alevia] sticky:', err.message);
            var live = bar.querySelector('[data-sticky-error]');
            if (live) live.textContent = err.message;
            restore();
          });
      });
    }
  }

  document.querySelectorAll('[data-sticky-atc]').forEach(initStickyATC);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-sticky-atc]').forEach(initStickyATC);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
